module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5aF3c"))).then(() => module.bundle.root('lKlEc'));